/* eslint-disable arrow-body-style */
/* eslint-disable no-useless-catch */
/* eslint-disable import/no-mutable-exports */
/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-expressions */
import axios from 'axios';
import constants from '../helpers/constants';
import teamModel from './team';
import Store from '../store/main';
// ===================================
// TODO
// в этом файле много методов которые используются по всему коду app/public
// но есть проблема в том что:
// 1. user.subscription.activites - это устаревшая непонятная хрень (например она равна 2 для юзера на новом плане зарегистрированном и оплатившем план в 2024. И она равна 6 для другого юзера. На это надо время чтоб удалить это и переписать)
// 2. user.team.activites - это тоже устаревшая непонятная хрень от которой надо избавиться
// я сильно не трогал этот файл, но надо его переписать на основе 1 и 2 пунктов
// и почистить бекенд от этого мусора
// по хорошему это все надо перенести в user.accountPlanData
// и убрать все эти поля из user.subscription

// точно не должны анализироваться на клиенте user.subscription и тем более  user.subscription.activites или  user.subscription.status_code
// team_users.status - не нужна
// ===================================

const plans = {};

plans.isTerminated = () => user.accountPlanData.is_terminated;
plans.isSubscriptionChargeFailed = () => user.accountPlanData.is_subscription_charge_failed;
plans.isRefunded = () => user.accountPlanData.is_refunded;
plans.isFinished = () => user.accountPlanData.is_finished;
plans.isPartialyRefunded = () => user.accountPlanData.is_partialy_refunded;
plans.isManualRenewal = () => user.accountPlanData.is_manual_renewal;
plans.isOrderProcessing = () => user.accountPlanData.is_order_processing;
plans.isSuspended = () => user.accountPlanData.is_suspended;
plans.isPlanManuallySetBySaleOnTrial = () => user.accountPlanData.is_plan_manually_set_by_sale_on_trial;
plans.isCustomPriceSetBySale = () => user.subscription.month_price_usd_custom || user.subscription.annual_price_usd_custom;
plans.isEnterpriseTeamPlan = () => user.accountPlanData.payment_plans_id === 17;
plans.isRealResourcesFromOldVersionPlansMoreThanMaxUsersCount = () => {
  const realUsers = Store.getters['resourcesModel/getAllRealResources'];

  return realUsers.length > plans.maxUserCountToInviteWithoutSale();
};

// Максимальное количество пользователей для приглашения без участия отдела продаж
plans.maxUserCountToInviteWithoutSale = () => constants.MAX_USER_COUNT_TO_INVITE_WITHOUT_SALE; // Вынеси это значение в константы, если оно повторяется

plans.isMaxUserCountToInviteWithoutSaleReached = () => {
  if (plans.isTrial()) {
    return user.team.invitations > plans.maxUserCountToInviteWithoutSale() || plans.isRealResourcesFromOldVersionPlansMoreThanMaxUsersCount();
  }

  if (plans.isOverSubscription()) {
    return plans.isRealResourcesFromOldVersionPlansMoreThanMaxUsersCount();
  }

  return user.team.invitations >= plans.maxUserCountToInviteWithoutSale();
}; /// user.subscription.user_count
plans.currencyCodeIsNotUsd = () => {
  if ('subscriptionCurrencyCode' in user.accountPlanData) {
    return user.accountPlanData.subscriptionCurrencyCode !== 'usd';
  }

  return false;
};

plans.isCanNotBeUpdatedWithoutSales = () => {
  const reasons = {
    manualRenewal: plans.isManualRenewal(),
    orderProcessing: plans.isOrderProcessing(),
    partiallyRefunded: plans.isPartialyRefunded(),
    manuallySetBySaleOnTrial: plans.isPlanManuallySetBySaleOnTrial(),
    isMaxUserCountToInviteWithoutSaleReached: plans.isMaxUserCountToInviteWithoutSaleReached(),
    customPrice: plans.isCustomPriceSetBySale(),
    isEnterpriseTeam: plans.isEnterpriseTeamPlan(),
    currencyCodeIsNotUsd: plans.currencyCodeIsNotUsd(),
  };

  const out = Object.keys(reasons).find(reason => reasons[reason]);

  if (out) {
    console.info(`%cWe can't provide upgrade popup because of this reason: ${out}`, 'color: yellow;');

    return out;
  }

  return false;
};

// Эта подписка не может быть обновлена и требует полностью новой подписки
plans.isRequireNewSubscriptionInsteadOfUpdate = () => {
  return plans.isTrial() // trial
  || plans.isTerminated() // terminated
  || plans.isRefunded() // refunded
  || plans.isFinished(); // finished
};

// #paymentDataPlan  remove this methods
// plans.isPaidTeam = () => _.includes([constants.PLANS.ESSENTIAL, constants.PLANS.TEAM_5, constants.PLANS.TEAM_10, constants.PLANS.TEAM_15], user.subscription.activites);

// plans.isTeam = () => user.subscription.activites > 0 && user.subscription.is_team === 1; // we don't used this method in code

// plans.isTrial = () => user.subscription.payment_plans_id === constants.PLANS.TEAM_TRIAL;
//
// plans.isActiveTrial = () => user.subscription.activites === constants.PLANS.TEAM_TRIAL;
//
// plans.isExpiredTrial = () => plans.isTrial() && user.subscription.activites === 0 || (plans.isResourcesMoreThanPaid() && !plans.isExpired());
//
// plans.isActiveSubscription = () => user.subscription.activites > 1 && user.subscription.status_code !== constants.PAYMENT_STATUSES.SUBSCRIPTION_SUSPENDED.CODE;
//
// plans.isOverSubscription = () => user.subscription.activites < 1 && !plans.isTrial();
//
// plans.isExpired = () => user.subscription.activites < 1;
//
// plans.isActive = () => user.subscription.activites > 1;
//
// plans.isActiveAccount = () => plans.getStatus() > 0 && user.team.status !== 2;
//
// plans.isActiveTeamAccount = () => {
//   const isUserAccount = plans.getStatus() >= 3; // Это значение можно вынести в константы, если оно повторяется
//
//   return isUserAccount && user.team.status !== 2;
// };

// rebuilded methods

plans.isPaidTeam = () => user.accountPlanData.payment_plans_id !== constants.PLANS.TEAM_TRIAL;

plans.isTrial = () => user.accountPlanData.payment_plans_id === constants.PLANS.TEAM_TRIAL;

plans.isActiveSubscription = () => user.accountPlanData.is_active || user.accountPlanData.is_active_trial;

plans.isOverSubscription = () => user.accountPlanData.is_expired; //  || user.accountPlanData.is_expired_trial

plans.isActiveTrial = () => user.accountPlanData.is_active_trial;

plans.isExpiredTrial = () => user.accountPlanData.is_expired_trial;

plans.isResourcesMoreThanPaid = () => {
  if (plans.isTrial()) {
    // сейчас триальным юзерам доступно 40 приглашений,
    // но могут возникнуть ошибки у юзеров которые были на триале до и во время обновления прайсинга,
    // так как они могли пригласить в команду 45 юзеров
    const trialInvitationsCount = 45;
    const invitedUsers = Store.getters['resourcesModel/getAllRealResources'];
    const trialCountOfLeftInvitation = trialInvitationsCount - invitedUsers.length;

    return trialCountOfLeftInvitation < 0;
  }

  return teamModel.getCountOfLeftInvitation() < 0;
};

plans.isActiveAccount = () => plans.isActive();

plans.isActiveTeamAccount = () => plans.isActive();

// new methods

plans.isAnnual = () => user.accountPlanData.is_annual; // подумать нужен ли он

plans.getSubscriptionName = () => user.accountPlanData.name; // подумать нужен ли он

plans.getSubscriptionProvider = () => user.accountPlanData.provider; // подумать нужен ли он

plans.getUserCount = () => user.accountPlanData.user_count;

plans.getExpiresDate = () => user.accountPlanData.date_to;

plans.getPlanId = () => user.accountPlanData.payment_plans_id;

plans.getStatusCode = () => user.accountPlanData.status_code;

plans.setStatusCode = id => user.accountPlanData.status_code = id;

plans.getPlanInfo = () => user.paymentPlans.find(plan => plan.id === plans.getPlanId());

plans.getPlanInfoById = id => user.paymentPlans.find(plan => plan.id === id);

plans.isActive = () => !plans.isFinished() && !plans.isTerminated() && !plans.isRefunded() && !plans.isSuspended() && !plans.isOverSubscription();

plans.isNotActive = () => plans.isFinished() || plans.isTerminated() || plans.isRefunded() || plans.isOverSubscription(); //  || plans.isSuspended() for suspend. All elements should be active

plans.getMask = () => user.accountPlanData.mask;

plans.getAnnualPrice = () => user.accountPlanData.annual_price_usd;

plans.getMonthPrice = () => user.accountPlanData.month_price_usd;

// plans.isCanCancelSubscription = () => !plans.isManualRenewal() && !plans.isOrderProcessing() && !plans.isPartialyRefunded() && !plans.isPlanManuallySetBySaleOnTrial();
plans.isCanCancelSubscription = () => !plans.isManualRenewal() && !plans.isOrderProcessing() && !plans.isPlanManuallySetBySaleOnTrial();

plans.getPlanName = () => user.accountPlanData.plan_name;

plans.getPlanTitleLocale = () => user.accountPlanData.plan_title_locale;

plans.getInvitations = () => user.team.invitations;

//

plans.getSubscriptionStatus = async provider => {
  try {
    const response = await axios.get('/payment/plan/getSubscriptionPriceDetails', { params: { provider } });
    // console.log(response.data);

    user.accountPlanData.subscriptionCurrencyCode = response.data.subscriptionCurrency?.toLowerCase();

    return response.data;
  } catch (error) {
    console.error('getSubscriptionStatus error', error);
  }
};

plans.upgradePlan = async upgradeData => {
  try {
    const response = await axios.post('/payment/plan/upgradePaymentPlan', upgradeData, {
      headers: { 'Content-type': 'application/json' },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

plans.sendLoginEmailForChangePaymentMethod = async () => {
  try {
    await axios.post('/payment/plan/sendOnetimeLoginEmail');
  } catch (error) {
    console.error(error);
  }
};

plans.getAffiliate = () => {
  if (user.affiliate && user.affiliate.percent && user.affiliate.coupon && user.affiliate.isStillValid) {
    return user.affiliate.percent;
  }

  return false;
};

export default plans;
